export default "__VITE_ASSET__44bd1c54__"